import validateKoinworks from './validateKoinworks';
import validateTaralite from './validateTaralite';
import validateModalku from './validateModalku';

const validate = values => {
  let errors = {};
  switch (values.lender_name.toLowerCase()) {
    case 'koinworks':
      errors = validateKoinworks(values);
      break;
    case 'taralite':
      errors = validateTaralite(values);
      break;
    case 'modalku':
      errors = validateModalku(values);
      break;
  }
  return errors;
};

export default validate;
